import { FC, ReactElement, memo } from 'react';
import { IOrderProduct } from '~/types/orders';
import { getTranslate } from '~/utils/helpers';
import { productUtils } from '~/utils/productUtils';
import { useOrderStoreContext } from '~/view/screens/OrderScreen/context';
import './style.scss';

interface IProps {
  product: IOrderProduct;
}

export const OrderProductHeader: FC<IProps> = memo(({ product }: IProps): ReactElement => {
  const { store: orderStore } = useOrderStoreContext();

  const productPrice: string = orderStore.formatPrice(productUtils.calculateOrderProductPrice(product));

  return (
    <div className="order-product-header">
      <p className="d-flex flex-row align-items-center">
        <span className="order-product-header__name">{getTranslate(product.name)}</span>

        {product.size?.name ? (
          <span className="order-product-header__name order-product-header__name-size">&nbsp;{`(${getTranslate(product.size.name)})`}</span>
        ) : null}

        <span className="order-product-header__name order-product-header__name-quantity">&nbsp;{product ? 'x' : ''}</span>
        <span className="order-product-header__name order-product-header__name-quantity">{product.quantity}</span>
      </p>

      <p className="order-product-header__price text-nowrap">{productPrice}</p>
    </div>
  );
});
